module.exports = __webpack_public_path__ + "staticcomp/img/marquee.58fd9a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/marquee.jpg
// module id = XVHt
// module chunks = 39